import { render, staticRenderFns } from "./ExamRecord.vue?vue&type=template&id=6fbdad1e&scoped=true"
import script from "./ExamRecord.vue?vue&type=script&lang=js"
export * from "./ExamRecord.vue?vue&type=script&lang=js"
import style0 from "./ExamRecord.vue?vue&type=style&index=0&id=6fbdad1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbdad1e",
  null
  
)

export default component.exports